import React from 'react'

import { UserInitial } from '@/components/UserInitial'
import { ExternalLink } from '@/components/ExternalLink'
import { LoadingInterstitial } from '../loaders/LoadingInterstitial'

import './AgentRow.scss'

export const AgentRow = ({
  index,
  agentFullName,
  description,
  descriptionLoading,
  externalLink,
}) => {
  return (
    <div className="agent-row flex-align-center flex-space-between gap">
      <div>
        <div className="name flex-align-center small-gap">
          <UserInitial userFullName={agentFullName} index={index} />
          <h2>{agentFullName}</h2>
        </div>
        {descriptionLoading ? (
          <LoadingInterstitial lines={[{ length: 'medium' }, { length: 'long' }]} className="mt" />
        ) : (
          description && <div className="description">{description}</div>
        )}
      </div>
      {externalLink && (
        <ExternalLink
          url={externalLink.url}
          label={externalLink.label}
          id={externalLink.id}
          onClick={(event) => {
            event.stopPropagation()
          }}
        />
      )}
    </div>
  )
}
